<template>
  <div class="pb-2 gradient-home-page">
    <div class="container pt-4">
      <!-- Описание сервиса -->
      <div class="bg-white p-4 rounded">
        <div class="d-flex flex-wrap justify-content-center gap-3">
          <div>
            <img
                src="/avatar.png"
                :style="{
                width: 'auto',
                height: '100px',
                maxWidth: '100%',
            }"
            />
          </div>

          <h3 class="mb-2 align-self-center text-center">
            <span class="fw-bold">Ninja-bot</span> - бесплатный конструктор <span class="">Telegram ботов</span> без рекламы
          </h3>
        </div>

        <div class="text-center mt-1">
          <router-link :to="{name: 'bots_list'}">
            <Button
                label="Личный кабинет"
                icon="pi pi-home"
                class="rounded m-1"
            />
          </router-link>

          <router-link :to="{name: 'doc_get_started'}">
            <Button
                label="Документация"
                class="rounded m-1"
                icon="pi pi-book"
                severity="secondary"
            />
          </router-link>

          <a href="https://t.me/ninja_bot_ru"  target="_blank">
            <Button
                label="Техническая поддержка"
                class="rounded m-1"
                icon="pi pi-telegram"
                severity="secondary"
            />
          </a>
        </div>
      </div>

      <!-- todo: Вернуть примеры расшаренных шаблонов!!! -->
<!--      <div class="mt-4 bg-light pt-lg rounded">-->
<!--        <h5 class="fw-bold text-center p-2">Первый бот за 15 минут 🕘</h5>-->

<!--        <div>-->
<!--          <Galleria :value="this.images" :responsiveOptions="responsiveOptions" :numVisible="5" :showThumbnails="false" :showIndicators="true" :show-indicators-on-item="true">-->
<!--            <template #item="slotProps">-->
<!--              <iframe-->
<!--                  :src="slotProps.item.itemImageSrc"-->
<!--                  style="width: 100%; min-height: 600px"-->
<!--              />-->
<!--            </template>-->
<!--            <template #thumbnail="slotProps">-->
<!--              <img :src="slotProps.item.thumbnailImageSrc" :alt="slotProps.item.alt" />-->
<!--            </template>-->
<!--            <template #caption="slotProps">-->
<!--              <div class="text-xl mb-4 font-bold">{{ slotProps.item.title }}</div>-->
<!--              <p class="text-white">{{ slotProps.item.alt }}</p>-->
<!--            </template>-->
<!--          </Galleria>-->
<!--        </div>-->
<!--      </div>-->

      <div class="mt-4">
        <div class="pt-lg p-4 rounded bg-warning border-2">
          <h5 class="fw-bold"><span class="pi pi-exclamation-circle"/> Внимание!</h5>
          <p>
            Ввод монетизации запланирован на 1 июня. Стоимость подписки составит <span class="fw-bold">300р/мес</span> за бота.
            Будет доступен один тариф, который предоставляет все функции системы без ограничений.
          </p>

          <p>
            Для новых пользователей, добавляющих бота впервые (бот ранее не подключенный к платформе), будет предоставлен пробный период в одну неделю.
          </p>

          <p>
            Все существующие боты в системе перейдут на платную модель с 1 июня. Если на балансе недостаточно средств, бот будет отключен.
          </p>
        </div>
      </div>

      <!-- Функции для Telegram групп -->
      <div class="mt-4">
        <div class="bg-light pt-lg p-4 rounded">
          <h5 class="text-center fw-bold">Функции для Telegram групп</h5>
          <Divider/>
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-lg-4 mb-2 mt-2 text-center" v-for="feature in this.featuresForTelegramGroups">
                <div>
                  <span :class="feature.icon" class="me-3"/>
                  <h5 class="d-inline fw-bold">{{ feature.name }}</h5>
                </div>
                <p class="mt-2 text-muted">{{ feature.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Функции для Telegram каналов -->
      <div class="mt-4">
        <div class="bg-light pt-lg p-4 rounded">
          <h5 class="text-center fw-bold">Функции для Telegram каналов</h5>
          <Divider/>
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-lg-4 mb-2 mt-2 text-center" v-for="feature in this.featuresForTelegramChannels">
                <div>
                  <span :class="feature.icon" class="me-3"/>
                  <h5 class="d-inline fw-bold">{{ feature.name }}</h5>
                </div>
                <p class="mt-2 text-muted">{{ feature.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Функции для приватных чатов Telegram -->
      <div class="mt-4">
        <div class="bg-light pt-lg p-4 rounded">
          <h5 class="text-center fw-bold">Режимы работы бота в личных сообщениях</h5>
          <Divider/>
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-lg-4 mb-2 mt-2 text-center" v-for="feature in this.featuresForTelegramBots">
                <div>
                  <span :class="feature.icon" class="me-3"/>
                  <h5 class="d-inline fw-bold">{{ feature.name }}</h5>
                </div>
                <p class="mt-2 text-muted">{{ feature.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {useAuthStorage} from "@/store";
import Menubar from "primevue/menubar";
import InputText from "primevue/inputtext";
import Avatar from "primevue/avatar";
import Badge from "primevue/badge";
import Button from "primevue/button";
import Divider from "primevue/divider";
import Galleria from "primevue/galleria";

export default defineComponent({
  name: 'HomePage',
  components: {
    Menubar,
    Avatar,
    InputText,
    Badge,
    Button,
    Divider,
    Galleria,
  },
  data: function () {
    return {
      responsiveOptions: [
        {
          breakpoint: '1300px',
          numVisible: 4
        },
        {
          breakpoint: '575px',
          numVisible: 1
        }
      ],
      images: [
        {
          itemImageSrc: 'https://ninja-bot.ru/bot/9b6d83cb-bbf0-40fc-978d-4992d5cb52f8/builder',
          thumbnailImageSrc: 'https://primefaces.org/cdn/primevue/images/galleria/galleria1s.jpg',
          alt: 'Description for Image 1',
          title: 'Title 1'
        },
        {
          itemImageSrc: 'https://ninja-bot.ru/bot/67daa36e-89ce-4a0c-b73d-b33e11bdc57f/builder',
          thumbnailImageSrc: 'https://primefaces.org/cdn/primevue/images/galleria/galleria1s.jpg',
          alt: 'Description for Image 1',
          title: 'Title 1'
        },
      ],
      featuresForTelegramGroups: [
        {
          name: 'Периодические сообщения',
          icon: 'bx bx-calendar-event',
          description: 'Периодическая отправка сообщений в чат, например правил сообщества',
        },
        {
          name: 'Команды ручной модерации',
          icon: 'bx bx-check-shield',
          description: 'Используйте /kick, /ban, /mute, /mute_media и т.д для быстрой ликвидации нарушителя',
        },
        {
          name: 'Капча',
          icon: 'pi pi-shield',
          description: 'Отсеивайте ботов с помощью разных видов капчи - эмодзи, текст с картинки, проверка подписки на каналы',
        },
        {
          name: 'Приветствие и прощание',
          icon: 'pi pi-sign-in',
          description: 'Приветствие новых и прощание с старыми участниками чата',
        },
        {
          name: 'Фильтры сообщений',
          icon: 'bx bx-block',
          description: 'Защита от распространение ссылок, telegram ссылок, флуда, использование мата',
        },
        {
          name: 'Прием заявок на вступление',
          icon: 'pi pi-check',
          description: 'Бот автоматически примет всех пользователей в закрытую группу',
        },
        {
          name: 'Триггеры',
          icon: 'bx bx-check-shield',
          description: 'Задайте собственные условия по которым бот выполнит необходимые действия, например по наличию в сообщении "ищу работу" - выгонять из чата',
        },
        {
          name: 'Статистика',
          icon: 'pi pi-chart-bar',
          description: 'Анализируйте количество пришедших и ушедших подписчиков',
        },
        {
          name: 'Часы работы',
          icon: 'pi pi-chart-pie',
          description: 'Закрывайте и открывайте чат во расписанию',
        },
        {
          name: 'Проверка участников',
          icon: 'bx bx-group',
          description: 'Кик удаленных аккаунтов, проверка username, описания профилей',
        },
        {
          name: 'Защита от накрутки',
          icon: 'pi pi-shield',
          description: 'При превышении допустимого лимита вступлений - бот автоматически забанит вступающих',
        },
      ],

      featuresForTelegramChannels: [
        {
          name: 'Отложенные публикации',
          icon: 'bx bx-calendar-event',
          description: 'Настройте дату публикации, нужно ли закреплять пост, когда открепить, через сколько удалить, куда переслать, количество повторов',
        },
        {
          name: 'Очереди публикаций',
          icon: 'pi pi-calendar-times',
          description: 'Задайте параметры периодичности публикации, система сама рассчитает когда необходимо выпустить следующий пост из очереди, для равномерного выхода контента',
        },
        {
          name: 'Перенаправление контента',
          icon: 'pi pi-arrow-right-arrow-left',
          description: 'Пересылайте контент в свой канал',
        },
      ],

      featuresForTelegramBots: [
        {
          name: 'Встроенный конструктор ботов',
          icon: 'pi pi-cog',
          description: 'Создайте бота который будет вести себя именно так как вы запланировали используя наш no-code графический редактор',
        },
        {
          name: 'Бот обратной связи',
          icon: 'pi pi-send',
          description: 'Принимайте и отвечайте на обращения клиентов через бота, не раскрывая личностей менеджеров',
        },
        {
          name: 'Рассылка',
          icon: 'pi pi-envelope',
          description: 'Производите рассылку по заготовленной базе пользователей',
        },
        {
          name: 'Реферальная система',
          icon: 'pi pi-share-alt',
          description: 'Построй собственную реферальную систему с своими условиями засчитывания перехода по ссылке',
        },
        {
          name: 'Бизнес бот',
          icon: 'pi pi-user',
          description: 'Исполнение бот сценариев от имени вашего премиум аккаунта в диалоге с клиентом',
        },
      ]
    }
  }
})
</script>

<style scoped>
.gradient-home-page {
  background: radial-gradient(circle, #679ef1, rgb(0, 0, 0));
}
</style>